import SuperAdminRoutes from './superAdmin';
import ShiftSupervisorRoutes from './shiftSupervisor';
import ResponsiblePersonRoutes from './responsiblePerson';
import AppointedOperatorRoutes from './AppointedOperator';
import AppointedPersonRoutes from './AppointedPerson';
import HotWorkMonitorRoutes from './HotWorkMoniter';
import SystemEngineerRoutes from './SystemEngineer';
import SectionHeadRoutes from './SectionHead';
import TechnicalManagerRoutes from './TechnicalManager';
import OperationManagerRoutes from './OperationalManager';
import PlannerRoutes from './Planner';
import SeniorPlannerRoutes from './SeniorPlanner';
import TechnicalSupportOfficerRoutes from './TechnicalSupportOfficer';
import RequestorRoutes from './Requestor';
import MaintenanceManagerRoutes from './MaintenanceManager';
import ResponsiblePersonHwaRoutes from './ResponsiblePersonHwa';
import AppointedPersonLVRoutes from './AppointedPersonLV';
import ResponsiblePersonLVRoutes from './ResponsiblePersonLV';
import ShiftAttendantRoutes from './ShiftAttendant';
import TechnicianRoutes from './Technician';

const routes = {
  super_admin: SuperAdminRoutes,
  shift_supervisor: ShiftSupervisorRoutes,
  responsible_person: ResponsiblePersonRoutes,
  appointed_operator: AppointedOperatorRoutes,
  appointed_person_hwa: AppointedPersonRoutes,
  hot_work_monitor: HotWorkMonitorRoutes,
  system_engineer: SystemEngineerRoutes,
  section_head: SectionHeadRoutes,
  technical_manager: TechnicalManagerRoutes,
  operation_manager: OperationManagerRoutes,
  planner: PlannerRoutes,
  senior_planner: SeniorPlannerRoutes,
  technical_support_officer: TechnicalSupportOfficerRoutes,
  requestor: RequestorRoutes,
  maintenance_manager: MaintenanceManagerRoutes,
  responsible_person_hwa: ResponsiblePersonHwaRoutes,
  responsible_person_lv: ResponsiblePersonLVRoutes,
  appointed_person_lv: AppointedPersonLVRoutes,
  shift_assistant: ShiftAttendantRoutes,
  shift_trainee: ShiftAttendantRoutes,
  technician: TechnicianRoutes,
};
export default routes;
